// extracted by mini-css-extract-plugin
export default {"container":"share_container__2O0Ag","inner":"share_inner__1WkLg","action":"share_action__3NnZk","image":"share_image__3Btm1","share":"share_share__tjnOK"};